import { get } from "lodash";
import { OnlineItemBaseController } from "./online-item-base.controller";
import { onlineT } from "../../typings/online";

export class LastBidderItemController extends OnlineItemBaseController {
    public static $inject: string[] = [
        "$element",
        "$scope",
        "categoryService",
        "mediaGalleryService",
        "onlineItemEdit",
        "onlinePriceService",
        "paymentService",
        "utilsService"
    ];

    // Binded
    public paymentStatus: onlineT.past.ItemStatus;

    public finalSoldPrice: number;
    public isItemSold: boolean;
    public lastBid: onlineT.LastBid;

    constructor(
        protected $element,
        protected $scope: ng.IScope,
        protected _categoryService,
        protected mediaGalleryService,
        protected onlineItemEdit,
        protected onlinePriceService,
        public paymentService,
        protected utilsService
    ) {
        super($element, $scope, _categoryService, mediaGalleryService, onlineItemEdit);
    }

    public $onInit() {
        this.lastBid = get(this.item, "pricing.last_bid");
        this.finalSoldPrice = get(this.item, "finalSoldPrice");

        this._watchInView();
    }
}
